module.exports = __webpack_public_path__ + "img/73.8f319adb.jpg";